import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MeasuringunitOptions } from "app/_models/optionsList/options";
import { FindiPurchaseOrderDetail } from "app/_models/purchaseOrders/purchaseOrderDetail";
import { CrudPurchaseOrderDetailsService } from "app/_services/MasterCrudOps/crud-purchase-order-details.service";
import { OptionslistService } from "app/_services/optionslist.service";
import { UiActionUtils } from "app/shared/utils/ui-action-utils";

@Component({
  selector: "app-edit-purchase-order-details",
  templateUrl: "./edit-purchase-order-details.component.html",
  styleUrls: ["./edit-purchase-order-details.component.css"],
})
export class EditPurchaseOrderDetailsComponent implements OnInit {
  poNumber: string;
  editPoDetailsForm: FormGroup;
  editPoOrderDetail: FindiPurchaseOrderDetail;
  units: MeasuringunitOptions[] = [];
  isLoaderResult: boolean = false;
  pageNumber: number;
  pageSize: number;

  constructor(
    private readonly crudPurchaseOrderDetailsService: CrudPurchaseOrderDetailsService,
    private readonly fb: FormBuilder,
    private readonly dialogRef: MatDialogRef<EditPurchaseOrderDetailsComponent>,
    private readonly optionListService: OptionslistService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.editPoOrderDetail = data.editPoOrderDetail;
    this.poNumber = data.poNumber;
    this.pageNumber = data.pageNumber;
    this.pageSize = data.pageSize;
  }

  ngOnInit(): void {
    this.editPoDetailsForm = this.fb.group({
      orderQuantity: [
        this.editPoOrderDetail.orderQuantity ?? "",
        [Validators.required, Validators.min(1), Validators.max(90000)],
      ],
      warrantyInMonths: [
        this.editPoOrderDetail.warrantyInMonths ?? "",
        [Validators.required, Validators.min(0), Validators.max(60)],
      ],
      unitPrice: [
        this.editPoOrderDetail.unitPrice ?? "",
        [Validators.required, Validators.min(0)],
      ],
      measuringUnitId: [
        this.editPoOrderDetail.measuringUnitId ?? null,
        [Validators.required],
      ],
    });

    this.getmeasuringUnits();
  }

  getmeasuringUnits() {
    this.optionListService.getMeasuringunitOptions().subscribe((data) => {
      this.units = data;
    });
  }

  updatePoDetails() {
    UiActionUtils.confirmUpdate("You won't be able to revert this!", () => {
      this.updateDetailAfterConfirms();
    });
  }

  updateDetailAfterConfirms() {
    this.isLoaderResult = true;
    let model = {
      PurchaseOrderDetailId: this.editPoDetailsForm.value.purchaseOrderDetailId,
      MeasuringUnitId: this.editPoDetailsForm.value.measuringUnitId,
      OrderQunatity: this.editPoDetailsForm.value.orderQuantity,
      WarrantyInMonths: this.editPoDetailsForm.value.warrantyInMonths,
      UnitPrice: this.editPoDetailsForm.value.unitPrice,
    };

    this.crudPurchaseOrderDetailsService
      .updatePurchaseOrderDetail(model)
      .subscribe(
        (data) => {
           this.isLoaderResult = false;
          if (data.didError) {
            UiActionUtils.showError(data.message, data.additionalMessage);
          } else {
            UiActionUtils.showSuccess(data.message);
            this.isLoaderResult = false;
            let result = {
              status: true,
              pageNumber: this.pageNumber,
              pageSize: this.pageSize,
            };
            this.dialogRef.close(result);
          }
        },
        (err) => {
          UiActionUtils.showError("Something went wrong", err.message);
          this.isLoaderResult = false;
        }
      );
  }

  close() {
    this.dialogRef.close(false);
  }
}
